module.exports = __webpack_public_path__ + "img/1-10.0af8baae.png";